import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { Splash } from "./components/Splash";
import { isNativeApp } from "./lib/native";
import { startTextSize } from "./lib/textSize";
import { initTheme } from "./lib/theme";
import "./index.css";

// Dynamic Type: the ios-native class opts the root into `font:
// -apple-system-body` (index.css) so WebKit follows the system text size;
// startTextSize layers the in-app zoom multiplier on top. Before render so
// the first paint is already at the right scale. Theme too — the saved
// light/dark choice must be on <html> before anything paints.
if (isNativeApp()) document.documentElement.classList.add("ios-native");
startTextSize();
initTheme();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <Splash />
  </React.StrictMode>
);

// Web/PWA only: the bundled native app serves from disk and must not register
// a service worker (the capacitor:// scheme doesn't support them anyway).
if ("serviceWorker" in navigator && !(window as unknown as { Capacitor?: unknown }).Capacitor) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* ignore registration failures */ });
  });
}
